import client, { publicClient } from './api-client'

/**
 * Fetch presigned URL for PMTiles layer
 * @param {string} layerName - Name of the layer (e.g., 'protected-areas')
 * @param {number} expiration - URL expiration time in seconds (optional)
 * @param {boolean} isPublic - Whether to use public API key authentication (optional)
 * @returns {Promise} Response containing presigned URL and layer metadata
 */
export async function getPMTilesUrl(layerName, expiration = null, isPublic = false) {
  let endpoint = `pmtiles/${layerName}/url/`

  if (expiration) {
    endpoint += `?expiration=${expiration}`
  }

  if (isPublic) {
    // Use public client with x-api-key authentication
    return publicClient(endpoint)
  } else {
    // Use existing JWT-based client
    return client(endpoint)
  }
}

export default {
  getPMTilesUrl
}
